import { Loader2, AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function LoadingBlock({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <Loader2 className="h-8 w-8 animate-spin text-pulse" aria-hidden />
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
}

export function ErrorBlock({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  const { t } = useTranslation("common");
  return (
    <div className="rounded-3xl border border-border bg-surface p-8 text-center">
      <AlertCircle className="mx-auto h-8 w-8 text-pulse" aria-hidden />
      <p className="mt-3 text-sm font-semibold">{t("errors.generic")}</p>
      <p className="mt-1 text-xs text-muted-foreground">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 rounded-2xl bg-gradient-pulse px-5 py-2.5 text-sm font-bold text-pulse-foreground"
        >
          {t("actions.retry")}
        </button>
      )}
    </div>
  );
}
